module.exports = __webpack_public_path__ + "assets/HKNova-ExtraLight.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraLight.woff
// module id = 114
// module chunks = 0